import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ed-localization-icon-button',
  imports: [CommonModule, MatIconButton, MatIcon, MatTooltip, RouterLink],
  templateUrl: './localization-icon-button.component.html',
  styleUrl: './localization-icon-button.component.scss',
  standalone: true,
})
export class LocalizationIconButtonComponent {}
